{
  "title": "Settings",
  "blocks": [
    {
      "type": "multi",
      "batches": [
        {
          "blocks": [
            {
              "type": "form",
              "hasSubmit": false,
              "jsonSchema": {
                "type": "object",
                "properties": {
                  "language": {
                    "title": "Language",
                    "default": "en",
                    "type": "string",
                    "description": "Select which language you would like to use for the App user interface",
                    "enum": [
                      "en",
                      "fr",
                      "de",
                      "pt",
                      "it",
                      "ru",
                      "ja",
                      "es",
                      "el"
                    ]
                  }
                }
              },
              "uiSchema": {}
            },
            {
              "type": "dispatch",
              "action": "switchLanguage"
            }
          ]
        },
        {
          "blocks": [
            {
              "type": "init"
            },
            {
              "type": "variable-get",
              "name": "settings",
              "default": {
                "defaultCorsProxy": "https://proxy.kendra.io/",
                "adapterRepoUrl": "https://kendraio.github.io/kendraio-adapter/",
                "showHelp": true,
                "debugMode": false,
                "disablePreview": true,
                "exposeCoreActions":false
              }
            },
            {
              "type": "form",
              "hasSubmit": false,
              "emitOnInit": true,
              "debounceTime": 100,
              "jsonSchema": {
                "type": "object",
                "properties": {
                  "defaultCorsProxy": {
                    "title": "Default CORS Proxy",
                    "type": "string",
                    "default": "https://kendraio-proxy.vercel.app/"
                  },
                  "adapterRepoUrl": {
                    "title": "Adapter repository base URL",
                    "description": "Enter the location of the adapter repository, including the final trailing slash",
                    "type": "string",
                    "default": "https://kendraio.github.io/kendraio-adapter/"
                  },
                  "showHelp": {
                    "title": "Show help?",
                    "type": "boolean",
                    "default": true
                  },
                  "debugMode": {
                    "title": "Debug mode",
                    "type": "boolean",
                    "default": false
                  },
                  "disablePreview": {
                    "title": "Disable prototypes and features under development",
                    "type": "boolean",
                    "default": false
                  },
                  "exposeCoreActions": {
                    "title": "Expose core actions to flows",
                    "description": "This will expose the core actions to custom flows, enabling the dynamic installation and modification of adapters.",
                    "type": "boolean",
                    "default": false
                  }

                }
              },
              "uiSchema": {}
            },
            {
              "type": "debug",
              "open": 0
            },
            {
              "type": "actions",
              "buttons": [
                {
                  "label": "Save settings",
                  "color": "primary",
                  "blocks": [
                    {
                      "type": "variable-set",
                      "name": "settings"
                    }
                  ]
                },
                {
                  "label": "Reset app",
                  "color": "warn",
                  "blocks": [
                    {
                      "type": "dialog",
                      "blocks": [
                        {
                          "type": "message",
                          "title": "Are you sure you want to reset the app?",
                          "message": "This action will remove all data and settings."
                        },
                        {
                          "type": "actions",
                          "buttons": [
                            {
                              "label": "OK",
                              "color": "primary",
                              "blocks": [
                                {
                                  "type": "dispatch",
                                  "action": "resetApp"
                                }
                              ]
                            },
                            {
                              "label": "Cancel",
                              "blocks": [
                                {
                                  "type": "init"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "id": "settings",
  "adapterName": "core"
}
